import { render, staticRenderFns } from "./ElemMenuBar.vue?vue&type=template&id=0a436cc2&"
import script from "./ElemMenuBar.vue?vue&type=script&lang=js&"
export * from "./ElemMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./ElemMenuBar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports